const DELIMITER = "~-~";

const joinStrings = (...strings) => {
  return strings.join(DELIMITER);
};
const splitStrings = (joinedString) => {
  return joinedString.split(DELIMITER);
};

const StringsHelper = { joinStrings, splitStrings };

export default StringsHelper;